module.exports = __webpack_public_path__ + "static/media/worknest-background.e04b3148.png";